import {transferify} from 'shared/utils/data-service-utils';
import type WalkerService from '../../services/walker.service';
import type ActionRequestDataService from '../../services/action-request-data.service';
import type {KpUniversalFormSettings} from 'src/commons/value-editors/kp-universal-form/types';

export default class SubmittingFormController {
    public static readonly controllerName = 'SubmittingFormCtrl';

    private static readonly recordsApiPathRegExp = new RegExp('/api/records');
    private static readonly recordHoldingsApiPathRegExp = new RegExp('/api/record-holdings');

    public formSetting: KpUniversalFormSettings<Record<string, any>>;
    public formObject: Record<string, any>;
    public submitFunction: (transferableFormObject: any) => void | Promise<any>;
    public closeDialogFunction: () => any;
    public customTransferifyFunction?: (object) => any;

    /*@ngInject*/
    constructor(private CONTEXT_PATH: string,
                private actionRequestDataService: ActionRequestDataService,
                private walker: WalkerService) {
    }

    public init(model: SubmittingFormActionModel, closeDialogFunction: () => any): void {
        this.formSetting = model.formSetting;
        this.formObject = model.formObject;
        this.submitFunction = (transferableFormObject) => {
            if (model.submitAsPage) {
                return Promise.resolve(this.walker.newPage(model.submitPath, transferableFormObject));
            }
            return this.actionRequestDataService.request(model.submitPath, model.submitMethod, transferableFormObject);
        }
        this.closeDialogFunction = closeDialogFunction;

        if (SubmittingFormController.requiresRecordPrefix(model.submitPath)) {
            this.customTransferifyFunction = (object) => transferify(object);
        }
    }

    private static requiresRecordPrefix(path) {
        return SubmittingFormController.recordsApiPathRegExp.test(path) || SubmittingFormController.recordHoldingsApiPathRegExp.test(path);
    }

}

export interface SubmittingFormActionModel {
    formSetting: KpUniversalFormSettings<Record<string, any>>;
    formObject: Record<string, any>;
    submitPath: string;
    submitMethod: string;
    submitAsPage: boolean;
}